import { cn } from '@/lib/utils';
import { PricingTierBadge } from './PricingTierBadge';
import type { PricingTier } from './PricingTiersTooltip';

interface PricingTiersListProps {
  tiers: PricingTier[] | null | undefined;
  className?: string;
  /** Показывать только активные тарифы. По умолчанию true. */
  onlyActive?: boolean;
  emptyText?: string;
  onTierClick?: (tier: PricingTier) => void;
}

export function PricingTiersList({
  tiers,
  className,
  onlyActive = true,
  emptyText = '—',
  onTierClick,
}: PricingTiersListProps) {
  if (!tiers || tiers.length === 0) {
    return <span className="text-muted-foreground">{emptyText}</span>;
  }

  const visible = onlyActive ? tiers.filter((t) => t.isActive) : tiers;
  if (visible.length === 0) {
    return <span className="text-muted-foreground">{emptyText}</span>;
  }

  const sorted = [...visible].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  return (
    <div className={cn('flex flex-wrap gap-1', className)} onClick={(e) => e.stopPropagation()}>
      {sorted.map((tier, index) => (
        <PricingTierBadge key={tier.id} tier={tier} index={index} onClick={onTierClick} />
      ))}
    </div>
  );
}
